/*"idPregunta":"idPregunta",
"value":"value", 
"texto1":"texto1", 
"texto2":"texto2", 
*/
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const RespuestaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Respuesta"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.idPregunta}>            
                              <label  >{strings?strings["idPregunta"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idPregunta"]:""} 
                                    name="idPregunta"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idPregunta}
                                    options={[]}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.value}>            
                              <label  >{strings?strings["value"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["value"]:""} 
                                    name="value"
                                    onChange={onChange}
                                    value={datos.value}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.texto1}>            
                              <label  >{strings?strings["texto1"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto1"]:""} 
                                    name="texto1"
                                    onChange={onChange}
                                    value={datos.texto1}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.texto2}>            
                              <label  >{strings?strings["texto2"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto2"]:""} 
                                    name="texto2"
                                    onChange={onChange}
                                    value={datos.texto2}
                                    icon='edit'/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/respuestas">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default RespuestaForm;